export default "__VITE_ASSET__DsKxYVVX__"